import FieldConfig from "../../proto/field-config";
import FieldDropdown from "../dropdown/dropdown";
import FieldDropdownLazyLoading_FormElement from "./render/form/form-element";
import FieldDropdownLazyLoading_FormElementView from "./render/form/form-element-view";


export default class FieldDropdownLazyLoading extends FieldDropdown {

    public isLoaded     : boolean       = false
    public _options     : any

    constructor(config:FieldConfig) {
        super(config);

        // special
        this.options                    = null; //_.get(config,'options',[]); // [{value, label, color},...]

        this.components.PopoverMenuMore     = null // never show edit options

        this.renderComponents.formElement       = FieldDropdownLazyLoading_FormElement
        this.renderComponents.formElementView   = FieldDropdownLazyLoading_FormElementView

        // this.hasOptionWithNullValue = false
        // // isn't it always fault
        // // this.hasOptionWithNullValue = _.some(this.options, (option:any)=>option.value === null);

    }

    async loadOptions(callback?:callback) {
        throw Error("#kdhjc000 not implemented")
    }

    // // // assumed to be redefined
    // // getOptions() {
    // //     return this._options || [];
    // // }
    //
    // getOptions() {
    //     return this.options || [];
    // }
    //
    // /*** IMPORT EXPORT ***/
    //
    // toJson() {
    //     let result = super.toJson();
    //     result.options = this.options;
    //
    //     return result;
    // }




}
